module.exports = __webpack_public_path__ + "img/hr-artillery-wagon-base-8.c20a3c7d.png";